// src/components/ToggleButton/ToggleButton.js
import React from "react";
import "./ToggleButton.scss";

const ToggleButton = ({ darkTheme, toggleTheme }) => {
  return (
    <div className="toggle-button" onClick={toggleTheme}>
      <div className={`toggle-circle ${darkTheme ? "dark" : "light"}`}>
        {darkTheme ? "🌙" : "☀️"}
      </div>
    </div>
  );
};

export default ToggleButton;
